import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AddButtonComponent } from "@components/add-button/add-button.component";
import { ToggleItemTextVisibilityButtonComponent } from "@components/toggle-item-text-visibility-button/toggle-item-text-visibility-button.component";
import { ToggleLockButtonComponent } from "@components/toggle-lock-button/toggle-lock-button.component";
import { ToggleVisibilityButtonComponent } from "@components/toggle-visibility-button/toggle-visibility-button.component";
import { FloorplanState } from "@domain/project/floorplan/floorplan-state";
import { FloorplanMenuItemButtonsComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-menu-item-buttons/floorplan-menu-item-buttons.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-measurement-line-menu",
  templateUrl: "./floorplan-measurement-line-menu.component.html",
  styleUrls: ["./floorplan-measurement-line-menu.component.scss"],
  imports: [
    UiKitModule,
    FloorplanMenuItemButtonsComponent,
    AddButtonComponent,
    ToggleLockButtonComponent,
    ToggleVisibilityButtonComponent,
    ToggleItemTextVisibilityButtonComponent,
  ],
  standalone: true,
})
export class FloorplanMeasurementLineMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplanState: FloorplanState;

  protected readonly tooltipTextAddMeasurement: string = $localize`:@@floorplan.button.addMeasurement:Neue Bemaßung hinzufügen`;

  constructor() {
    this.floorplanState = this.floorplanService.selectedFloorplan.floorplanState;
  }

  addMeasurementLine() {
    this.floorplanService.addMeasurementLine();
  }

  dragMeasurementLine() {
    this.dragDropService.setDragged({ type: DraggedItemType.MEASUREMENT_LINE });
  }

  protected updateMeasurementLinesItemTextVisibility(visible: boolean) {
    this.floorplanState.updateMeasurementLinesItemTextVisibility(visible);
  }
}
